import jwtDecode from 'jwt-decode';
export default function decodeIdToken(token) {
  var _unpackedJwt, _unpackedJwt2;
  var unpackedJwt = {
    email: '',
    name: '',
    exp: null,
    profile: {
      employeeId: ''
    }
  };
  try {
    if (token !== null && token !== void 0 && token.length) {
      unpackedJwt = jwtDecode(token);
    }
  } catch (e) {
    console.log(e);
  }
  if (unpackedJwt && !((_unpackedJwt = unpackedJwt) !== null && _unpackedJwt !== void 0 && (_unpackedJwt = _unpackedJwt.email) !== null && _unpackedJwt !== void 0 && _unpackedJwt.length) && (_unpackedJwt2 = unpackedJwt) !== null && _unpackedJwt2 !== void 0 && (_unpackedJwt2 = _unpackedJwt2.name) !== null && _unpackedJwt2 !== void 0 && _unpackedJwt2.length) {
    unpackedJwt.email = unpackedJwt.name;
  }
  return unpackedJwt;
}